export const getErrorMessage = (err: unknown, fallback: string): string => {
    if (err && typeof err === "object") {
        const anyErr = err as Record<string, unknown>;

        // Field-level validation errors (e.g. { errors: { name: "field required" } }),
        // a common shape for 422 responses — surface the specific field(s) at fault.
        if (anyErr.errors && typeof anyErr.errors === "object") {
            const details = Object.entries(anyErr.errors as Record<string, unknown>)
                .map(([field, message]) => `${field}: ${message}`)
                .join("; ");
            if (details) return details;
        }

        if (typeof anyErr.error === "string") return anyErr.error;
        if (typeof anyErr.message === "string") return anyErr.message;
    }
    return fallback;
};
